import * as core from '../../../../../../../core'

import { query } from './training-implications-by-functional-area.query'

export const RESOURCE = {
  payload: {
    alias: 'training.implications.by.functional.area',
    description: 'Chart view of training implications by functional area',
    name: 'Training Implications by Functional Area',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
